
    import { mapGetters } from "vuex";


	export default {
		components: {},
		data: function () {
			return {};
		},
		computed: {

			...mapGetters({
                 productStock: "getProductStock",
             }),
			automaticPromotionText() {
				return this.options.AutomaticPromotions &&
					this.options.AutomaticPromotions.data.length > 0
					? this.options.AutomaticPromotions.data[0].display_text
					: false;
			},


			getButtonText() {
				return this.buttonText != "" ? this.buttonText : "Select";
			},

			imageUrl() {
				if (this.options.Images[0]) return this.options.Images[0].url;
				return "";
			},

			/**
			 * Gets product price range from lowest price modifier to highest and returns as a string
			 * @return object
			 */

			priceRange() {
				var range = [
					{ value: false, display: false },
					{ value: false, display: false },
				];

				if (this.options.bundle) {
					return this.getPriceDisplayValue(this.options.price, 1);
				}

				if (this.options.PriceModifiers.length > 0) {
					for (var i = 0; i < this.options.PriceModifiers.length; i++) {
						if (range[0].value === false) {
							range[0].value = this.options.PriceModifiers[i].price;
							range[0].display = this.getPriceModifierDisplayValue(
								this.options.PriceModifiers[i],
								1
							);
						}
						if (range[1].value === false) {
							range[1].value = this.options.PriceModifiers[i].price;
							range[1].display = this.getPriceModifierDisplayValue(
								this.options.PriceModifiers[i],
								1
							);
						}

						if (this.options.PriceModifiers[i].price < range[0].value) {
							range[0].value = this.options.PriceModifiers[i].price;
							range[0].display = this.getPriceModifierDisplayValue(
								this.options.PriceModifiers[i],
								1
							);
						}

						if (this.options.PriceModifiers[i].price > range[1].value) {
							range[1].value = this.options.PriceModifiers[i].price;
							range[1].display = this.getPriceModifierDisplayValue(
								this.options.PriceModifiers[i],
								1
							);
						}
					}

					// If custom price modifiers are allowed, use the min value if it's lower than the lowest price modifier
					if (this.options.allow_custom_price_modifier && this.options.webshop_min_custom_value) {
						if (this.options.webshop_min_custom_value < range[0].value) {
							range[0].value = this.options.webshop_min_custom_value;
							range[0].display = this.getPriceDisplayValue(this.options.webshop_min_custom_value, 1);
						}
					}
					return range[0].value == range[1].value
						? range[1].display
						: "From " + range[0].display;
				} else {
					// If custom price modifiers only
					return "From " + this.getPriceDisplayValue(this.options.webshop_min_custom_value, 1)
				}

			},
		},
		props: ["options", "buttonText"],
		created: function () {},
		mounted: function () {},
		methods: {},
	};
